import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Buffer } from 'buffer';

import { useForm } from '../../../hooks/useForm';
import { useValidateDynamicForm } from '../../../hooks/useValidateDynamicForm';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useApiResolver } from '../../../hooks/useApiResolver';
import { useNotification } from '../../../hooks/useNotification';

import { callApi } from '../../../services/api.service';
import { isNotEmptyObject, safeParseJSON } from '../../../utils/jsonValidator';
import { ensureArray } from '../../../utils/validateResponseApi';
import { useResolveBodyData } from '../../../hooks/useResolveBodyData';
import { useDispatch, useSelector } from 'react-redux';

import { setSessionStateActionRequired, setSessionStateActionsPending } from '../../../redux/actions/sessionState';
import useResolveCompanyInfo from '../../../hooks/useResolveCompanyInfo';


export default function useManageSmartFormEngine() {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [{ userSession }] = useDataAuth();
    const [sendNotification] = useNotification();
    const { resolveValue } = useApiResolver();
    const [userAction, setuserAction] = useState(null);
    const [configuration, setconfiguration] = useState(null);
    const [scheme, setscheme] = useState([]);

    const companyInfo = useResolveCompanyInfo();
    const { resolveInfo, resetInit, setBodyData } = useResolveBodyData();
    const [errorInputs, validForm] = useValidateDynamicForm();
    const [values, handleInputChange, handleDirectInputChange] = useForm();

    const { actionPending } = useSelector((state) => state.sessionState);

    useEffect(() => {
        if (isNotEmptyObject(actionPending) && configuration)
            resolveInfo(actionPending);
    }, [configuration])

    const setValuesSelectGeneric = (e) => {
        const { name, value, fullObject } = e.target;
        handleDirectInputChange(name, value);
        if (isNotEmptyObject(fullObject)) {
            resolveInfo(fullObject, name);
        }
    }

    const setFileTemp = (bytes, field) => {
        const u8 = new Uint8Array(bytes);
        var b64 = Buffer.from(u8).toString('base64');
        handleDirectInputChange(field + '_file_B64', b64);
    }

    const handleFileChange = (event, field) => {
        handleDirectInputChange(field, event.target.files[0].name);
        const asfile = event.target.files[0];
        if (asfile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const arrayBuffer = e.target.result;
                const bytes = new Uint8Array(arrayBuffer);
                setFileTemp(bytes, field);
            };
            reader.readAsArrayBuffer(asfile);
        }
        event.target.value = '';
    };

    useEffect(() => {
        const info = location.state.config;
        if (info) {
            callApi("user_select", "MENU_ID", { id_user_action: info.id_user_action }, userSession.token, { findOne: 'true' })
                .then(({ data }) => {
                    setuserAction(data);
                    const confg = safeParseJSON(data.configuration);
                    setconfiguration(confg);
                    setscheme(ensureArray(confg?.form));
                    const trigger = safeParseJSON(confg.trigger[0]);
                    setBodyData(safeParseJSON(trigger?.bodyData));
                    if (confg?.isActionRequired)
                        dispatch(setSessionStateActionRequired(true));
                }).catch((e) => {
                    console.error('ERROR getColumns', e);
                });
        }
    }, [dispatch, location.state, setBodyData, userSession.token]);

    const handleSubmit = async () => {
        if (!validForm(scheme, values)) return;

        const { url, method } = configuration.trigger[0];
        const body = resolveInfo(values);
        const config = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: JSON.stringify(body)
        };
        const response = await resolveValue(config);
        console.log('Response ', response);
        if (response.status === 200 && !response.errorCode) {
            console.log('!response.errorCode ', !response.errorCode);
            if (configuration?.isActionRequired) {
                console.log('!response.errorCode ', !response.errorCode);
                configuration.isActionRequired = false;
                dispatch(setSessionStateActionRequired(false));
            }
        }
        if (!response.errorCode)
            Cancel();
        else
            resolveInfo(actionPending, null, true);
    }

    const Cancel = () => {
        if (configuration?.isActionRequired) {
            console.log('Paso AAA ');
            sendNotification({
                msg: "Debes completar esta acción para continuar",
                variant: "error",
            });
            navigate('/home');
        }
        else {
            dispatch(setSessionStateActionsPending(''));
            userSession.pending_action = '';
            navigate('/home');
        }
    }

    return {
        title: userAction?.name || '',
        values,
        errorInputs,
        scheme,
        companyInfo,
        handleInputChange,
        handleDirectInputChange,
        setValuesSelectGeneric,
        handleFileChange,
        loading: false,
        handleSubmit,
        Cancel
    }
}
